const prefix = 'game-room';

export const createRoom = `${prefix}`;
export const updateRoom = (roomId: string) => `${prefix}/${roomId}`;
export const deleteRoom = (roomId: string) => `${prefix}/${roomId}`;

export const getRooms = `${prefix}`;

export const getRoomDetail = (roomId: string) => `${prefix}/${roomId}`;
